/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListBankAccountRibDto } from '../../models/api-response-list-bank-account-rib-dto';

export interface GetBankAccountsByMethod$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  methodReference: string;
}

export function getBankAccountsByMethod(http: HttpClient, rootUrl: string, params: GetBankAccountsByMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListBankAccountRibDto>> {
  const rb = new RequestBuilder(rootUrl, getBankAccountsByMethod.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('methodReference', params.methodReference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListBankAccountRibDto>;
    })
  );
}

getBankAccountsByMethod.PATH = '/v1/api/payment-methods/{methodReference}/bank-accounts';
